import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { useMFContext } from 'components/MFHelpers'
import styled from 'styled-components'

const Header = ({
  tenant,
  colorMode,
}: {
  tenant: Tenant
  colorMode: 'light' | 'dark' | undefined
}) => {
  const { _t } = useMFContext()
  return (
    <TextWidth>
      <HeaderContainer>
        <img
          src={require(colorMode == 'dark'
            ? './mittelstand_header_dm.gif'
            : './mittelstand_header.gif')}
        />
      </HeaderContainer>
    </TextWidth>
  )
}

const ContentContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  z-index: 10;

  /* background-color: var(--yellow-main); */
  padding: 15px;
  padding-top: 60px;
`
const HeaderContainer = styled.div`
  height: 460px;
  position: relative;
  border-bottom: 3px solid var(--text-color);
  overflow: hidden;
  margin-bottom: 80px;
  color: var(--text-color);
  img {
    transform: scale(0.8);
    position: absolute;
    bottom: -100px;
    left: 0;
    width: 100%;

    &.ddd {
      z-index: 20;
    }
  }
  h2 {
    font-size: 44px;
    line-height: 48px;
    text-align: center;
    /* max-width: 500px;
    padding: 30px 15px;
    margin-left: auto;
    margin-right: auto; */
    /* font-family: var(--font-serif); */
  }

  h3 {
    width: 100%;
    font-weight: 300;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
  }
  @media screen and (max-width: 712px) {
    height: 620px;
    margin-bottom: 20px;
    img {
      transform: scale(1);
      position: absolute;
      bottom: -20px;
    }
    h2 {
      font-size: 33px;
      line-height: 38px;
    }
    h3 {
      font-size: 18px;
      line-height: 27px;
    }
  }
`

const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: 100%;
  text-align: center;

  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  /* border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'}; */
  /* padding-top: 2rem; */

  button {
    &:hover {
      cursor: pointer;
    }
    padding: 0;
    border: 0;
    background-color: transparent;
  }
  a,
  button {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span {
    white-space: nowrap;
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
const Publication = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  margin-bottom: 60px;
  flex: 0 0 100%;
  text-align: center;
`
export default Header
